import { Api } from '@/api/api';
import { CustomersResult } from '@/models/customers-result';
import { User } from '@/models/user';

export class CustomerApi extends Api {
    public async fetchAsync(): Promise<CustomersResult> {
        return await this.getAsync<CustomersResult>('v2/customer');
    }
    public async fetchUsersForCustomerAsync(customerId: string): Promise<Array<User>> {
        return await this.getAsync<Array<User>>(`v2/customer/${customerId}/user`);
    }
    public async grantCustomerAccessAsync(customerId: string, userId: number): Promise<void> {
        await this.postAsync<void>(`v2/customer/${customerId}/user`, { userId: userId });
    }
    public async revokeCustomerAccessAsync(customerId: string, userId: number): Promise<void> {
        await this.deleteAsync<void>(`v2/customer/${customerId}/user/${userId}`);
    }
    public async grantSiteAccessAsync(customerId: string, siteId: string, userId: number): Promise<void> {
        await this.postAsync<void>(`v2/customer/${customerId}/site/${siteId}/user`, { userId: userId });
    }
    public async revokeSiteAccessAsync(customerId: string, siteId: string, userId: number): Promise<void> {
        await this.deleteAsync<void>(`v2/customer/${customerId}/site/${siteId}/user/${userId}`);
    }
    public async grantSitePermissionAsync(customerId: string, siteId: string, permissionId: string, userId: number): Promise<void> {
        await this.postAsync<void>(`v2/customer/${customerId}/site/${siteId}/permission/${permissionId}/user`, { userId: userId });
    }
    public async revokeSitePermissionAsync(customerId: string, siteId: string, permissionId: string, userId: number): Promise<void> {
        await this.deleteAsync<void>(`v2/customer/${customerId}/site/${siteId}/permission/${permissionId}/user/${userId}`);
    }
}
